import * as React from "react";
const SvgCardFintech = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 4v16h22V4H1Zm5 5H3V6h3v3Zm6 6c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Zm9 3h-3v-3h3v3Z", fill: "#000" }));
export default SvgCardFintech;
